import React, { useEffect, useMemo, useRef, useState } from 'react'
import { history, latinAlphabet } from '../../utils/variables'
import Timer from '../../components/master/Timer'
import Modal from '../../components/master/Modal'
import ImageZoom from '../../components/master/ImageZoom'
import { pexios, toast } from '../../utils/functions'
import { useSelector } from 'react-redux'
import { t } from 'i18next'
import VehicleCard from '../../assets/images/sample_images/car-cart.png';
import VehicleCardBack from '../../assets/images/sample_images/back-car-cart.png';
import FrontCar from '../../assets/images/register-samples/front.png'
import BackCar from '../../assets/images/register-samples/back.png'
import FrontLeftCar from '../../assets/images/register-samples/left-front.png'
import LeftCar from '../../assets/images/register-samples/left.png'
import BackLeftCar from '../../assets/images/register-samples/left-back.png'
import BackRightCar from '../../assets/images/register-samples/right-back.png'
import RightCar from '../../assets/images/register-samples/right.png'
import FrontRightCar from '../../assets/images/register-samples/right-front.png';
import Chassis from '../../assets/images/register-samples/chassis.png'
import LicenseImage from '../../assets/images/sample_images/license.png';
import BackLicenseImage from '../../assets/images/sample_images/back-license.png';
import ThirdImage from '../../assets/images/sample_images/third-image2.jpg';
import StopWatch from '../../assets/images/icons/stopwatch.png';
import Loader from '../../components/master/Loader'

function FinalImages() {
    const [screenCamera,setScreenCamera] = useState(false)
    const videoRef = useRef(null);
    const [loader, setLoader] = useState(false);
    const [showPicture,setShowPicture] = useState('')
    const [notif,setNotif] = useState(true);
    const [imgIndex,setImgIndex] = useState(0);
    const [content, setContent] = useState('');
    const [data, setData] = useState({losses :[],images:[]});
    const { id } = useSelector(store => store.routerData);
    useEffect(() => {
        pexios('/api/v2/get_accident', 'post', { accident_id: id , type : 'expert_image' })
            .then(res => {
                const { losses } = res.data.data;
                setData(prevState=>({...prevState,losses:losses}))
            });
    }, [id]);
    const imagesLabels = useMemo(()=>{
        const baseImageLabels = [
            'front_image',
            'right_image',
            'back_image',
            'left_image',
            'chassis_number',
            'license_image',
            'license_back_image',
            'vehicle_card_image',
            'vehicle_card_back_image',
            'third_image',
        ]
        let labels =[]
        baseImageLabels.map((label)=>(
            labels.push(`expert_culprit_${label}`)
        ))
        if(!!data.losses.length){
            for(let i =0;i <data.losses.length;i++){
                baseImageLabels.map((label)=>(
                labels.push(`expert_losses_${label}${i+1}`)
                ))
            }
        }
        else {
            labels.push(`expert_culprit_body_image`)
        }
        return labels
    },[data.losses])
    useEffect(() => {
        let close
        setLoader(true)
        const startCamera = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    close = setTimeout(() => setNotif(false), 3000)
                    setContent('picker')
                    setLoader(false)
                }
            } catch (error) {
                console.error("Error accessing the camera: ", error);
                toast('دسترسی به دوربین خود را فعال کنید', 'error');
            }
        };
        startCamera();
        return () => {
            if (videoRef.current && videoRef.current.srcObject) {
                const stream = videoRef.current.srcObject;
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
                videoRef.current.srcObject = null;
                clearTimeout(close)
            }
        };
    }, [screenCamera]);
    useEffect(() => {
        let timer
        if (content === 'picker' && imagesLabels.length - 1 !== imgIndex) {
            timer = setInterval(() => {
                backgroundIImageCapturing()
                // setBgImgIndex(prevState => prevState + 1)
            }, 1000)
        }
        return () => {
            clearInterval(timer)
        }
    }, [content])
    function uploadDoc(image, name, done) {
        let { images } = data;
        let fd = new FormData();
        fd.append('id', id);
        fd.append('type', 'accident');
        fd.append(name, image);
        pexios('api/upload_image', 'post', fd, true).then(res => {
            const index = images.findIndex(itm => itm.filename === name);
            if (index !== -1)
                images[index] = res.data;
            else
                images.push(res.data);
            setShowPicture(res.data.uid)
            setData(prevState => ({ ...prevState, images: images }))
            done();
        }).catch(err => {
            console.log(err.response)
        });
    }
    function getImage(dataUrl) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = dataUrl;
            image.onload = () => {
                resolve(image);
            };
            image.onerror = (el, err) => {
                reject(err.error);
            };
        });
    }
    function createImage(image) {
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            // if (currentRes > 1080) {
            const newSize = longestDimension === 'width'
                ? Math.floor(oldHeight / oldWidth * 1080)
                : Math.floor(oldWidth / oldHeight * 1080);
            newWidth = longestDimension === 'width' ? 1080 : newSize;
            newHeight = longestDimension === 'height' ? 1080 : newSize;
            // }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                uploadDoc(blob, imagesLabels[imgIndex], () => {
                    setTimeout(() => setLoader(false), 500);
                });
            }, 'image/jpeg', 0.7);
        }
    }
    function backgroundIImageCapturing() {
        const image = videoRef.current;
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            // if (currentRes > 1080) {
            const newSize = longestDimension === 'width'
                ? Math.floor(oldHeight / oldWidth * 400)
                : Math.floor(oldWidth / oldHeight * 400);
            newWidth = longestDimension === 'width' ? 400 : newSize;
            newHeight = longestDimension === 'height' ? 400 : newSize;
            // }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('type', `bg_accident`);
                fd.append('image', blob);
                pexios('/api/upload_background_image', 'post', fd, true)
            }, 'image/jpeg', 0.7);
        }
    }
    async function takePicture() {
        setLoader(true)
        const image = videoRef.current;
        image && createImage(image)
    }
    function AcceptOrDeclineBtns(type) {
        if (type === 'accept') {
            if (imagesLabels.length - 1 === imgIndex) {
                pexios('/api/finish_image_progress', 'post', { id: id, type: `bg_accident` })
                    .then(() => {
                        history.push('/final-pricing')
                    })
            }
            else setImgIndex(prevState => prevState + 1)
        }
        setShowPicture('')
    }
    function ChangeImage(type) {
        if (imagesLabels.length - 1 === imgIndex && type === 'next') {
            pexios('/api/finish_image_progress', 'post', { id: id, type: `bg_accident` })
                .then(() => {
                    history.push('/final-pricing')
                })
        }
        else if (type === 'next') setImgIndex(prevState => prevState + 1)
        else if (type === 'prev' && imgIndex > 0) setImgIndex(prevState => prevState - 1)
    }
    async function submitImage(e) {
        const [file] = e.target?.files || [];
        setContent('loader');
        if (file) {
            const url = window.URL.createObjectURL(file);
            const image = await getImage(url);
            const oldWidth = image.naturalWidth;
            const oldHeight = image.naturalHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                uploadDoc(blob, imagesLabels[imgIndex], () => {
                    setTimeout(() => setContent('picker'), 500);
                });
            }, 'image/jpeg', 0.7);
        }
    }
    function findUserType() {
        if(imagesLabels[imgIndex].includes('culprit')) return t('Culprit')
        else {
            const lossesIndex = imagesLabels[imgIndex].slice(-1)
            return `${t('Losses')} ${t(latinAlphabet[lossesIndex-1])}`
        }
    }
    const imagesData = {
        'vehicle_card_image' : {name: 'vehicle_card_image',title:t('Vehicle card'),src: VehicleCard,gallery: true},
        'vehicle_card_back_image' : {name: 'vehicle_card_back_image',title:t('Vehicle card back'),src: VehicleCardBack,gallery: true},
        'license_image' : {name: 'license_image',title :t('License'),src: LicenseImage,gallery: true},
        'license_back_image' : {name: 'license_back_image',title :t('License back'),src: BackLicenseImage,gallery: true},
        'front_image' : {name:  'front_image',title:t('Front vehicle'),src: FrontCar},
        'front_left_image' : {name: 'front_left_image',title:t('Front Left vehicle'),src: FrontLeftCar},
        'left_image' : {name:  'left_image',title:t('Left side vehicle'),src: LeftCar},
        'back_left_image' : {name: 'back_left_image',title:t('Back Left vehicle'),src: BackLeftCar},
        'back_image' : {name:  'back_image',title:t('Back vehicle'),src: BackCar},
        'back_right_image' : {name: 'back_right_image',title:t('Back Right vehicle'),src: BackRightCar},
        'right_image' : {name:  'right_image',title:t('Right side vehicle'),src: RightCar},
        'front_right_image' : {name: 'front_right_image',title:t('Front Right vehicle'),src: FrontRightCar},
        'chassis_number' : {name: 'chassis_number',title:t('Engraved chassis number'),src: Chassis},
        'third_image' : {name:  'third_image',title :t('Third insurance'),src: ThirdImage,rotate: true,gallery: true},
        'body_image' : {name:  'body_image',title :t('Body insurance'),src: ThirdImage,rotate: true,gallery: true},
    }
    function getImageDetail(type) {
        for( const [key , value] of Object.entries(imagesData)) {
            if(imagesLabels[imgIndex].includes(key)) return value[type] ||''
        }
    }
  return (
    <div className='content'>
    {!screenCamera ? 
    <div className='final-images'>
        <p className='guide-text mx10 my20'>
            کارشناس محترم ، در این بخش شما می توانید در صورت نیاز با زدن دکمه شروع تصویر برداری اقدام به تصویربرداری به صورت کامل از مدارک و خودرو طرفین حادثه نمایید. 
        </p>
        <p className='guide-text mx10 my20'>
            در صورتی که تصاویر پرونده کامل می باشد می توانید با زدن دکمه تصاویر کامل می باشد از این بخش عبور کنید.
        </p>
        <div className='d-flex mt40 pr5 pl5'>
            <button
                onClick={() => history.push('/final-pricing')}
                className='btn btn-orange btn-block btn-circle m10'
            >
                تصاویر کامل میباشد
            </button>
            <button
                onClick={() => setScreenCamera(true)}
                className='btn btn-white-purple btn-block btn-circle m10'
            >
                شروع تصویربرداری
            </button>
        </div>
    </div>
    :
    <Modal visible={true}>
            { loader &&
                <Modal visible={loader}>
                    <div className='loader-modal'>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                    {/* <Loader/> */}
                </Modal>
            }
            {showPicture &&
                <Modal visible={true}>
                    <div className='image-modal'>
                        <ImageZoom imgUid={showPicture}/>
                        <div className='d-flex accept-or-decline-btn'>
                            <button className='btn navigate-btn'onClick={()=>AcceptOrDeclineBtns('reject')}><span className='fas fa-times'/></button>
                            <button className='btn navigate-btn'onClick={()=>AcceptOrDeclineBtns('accept')}><span className='fas fa-check'/></button>
                        </div>
                    </div>
                </Modal>
            }
            {
            <div className='screen-camera'>
                <video ref={videoRef} autoPlay playsInline muted style={{ height: '100%'}}></video>
                {content === 'picker' &&
                <>
                    {notif &&
                    <div className='tuturial-notif'> 
                        <i className='fas fa-times' onClick={()=> setNotif(false)}/>
                            لطفا در بازه زمانی مشخص شده تصاویر درخواستی را بارگذاری نمایید 
                    </div>
                    }
                <div className='register-timer'>
                    <Timer seconds={1200} onFinish={()=>history.push('/final-pricing')} />
                    <div className='timer-img'><img src={StopWatch} alt="timer"/></div>
                </div>
                
                <div key={imagesLabels[imgIndex]}>
                    <h5 className=' border-bottom image-title'> {getImageDetail('title')} {findUserType()}</h5>
                    <img className={`sample-img ${getImageDetail('rotate') ? 'not-rotate':''}`} src={getImageDetail('src')} alt="sample"/>
                </div>
                
                <div className='d-flex justify-center align-items-center navigate-btns'>
                    <button className='capture-btn' onClick={takePicture}/>
                </div>
                {<label className='btn-ontrol next-btn' onClick={()=>ChangeImage('next')}>بعدی</label>}
                {imgIndex !== 0 && <label className='btn-ontrol prev-btn' onClick={()=>ChangeImage('prev')}>قبلی</label>}
                {getImageDetail('gallery') && 
                    <label className='gallery-btn'>
                        انتخاب از گالری
                        <input type='file' accept='image/*' style={{display: 'none'}} onChange={submitImage}/>
                    </label>
                }
                </>
                }
            </div>
            }
        </Modal>
    }
    </div>
  )
}

export default FinalImages